// strings/common.ts (M0-T02, so every W2 task has base keys) — format example, complete for common
import type { StringBank } from '../schema/strings';

export default {
  appName: 'Whiskerton',
  ok: 'OK', cancel: 'Cancel', back: 'Back', done: 'Done', retry: 'Try again', loading: 'Loading…', close: 'Close',
  notice: 'Something happened.',
  currency: 'bell', currencyPlural: 'bells',
  bells: '{n:num} {n|currency}',                         // rev 9: the currency form, never the literal word
  formerResident: 'a former resident',
} as const satisfies StringBank;
